/* Gerado por tools/import-pokeidle-loot.mjs — não editar à mão. */
export const SPECIES_LOOT = {
  "bulbasaur": [
    {
      "slug": "drop-poison-bottle",
      "chance": 71498,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 71498,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 71498,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 20092,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 1675,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "ivysaur": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 31132,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 11675,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 1946,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 292,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "leaf-stone",
      "chance": 292,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "venusaur": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 21,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 21,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 52990,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 29698,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 5008,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 582,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "leaf-stone",
      "chance": 582,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "charmander": [
    {
      "slug": "drop-essence-fire",
      "chance": 74396,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 74396,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 3068,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "charmeleon": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 41600,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 3782,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 567,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "charizard": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 21,
      "stone": false
    },
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 21,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 44936,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 5443,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 633,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "feather-stone",
      "chance": 633,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "drop-dragon-tooth",
      "chance": 633,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "squirtle": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "squirtle-hull",
      "chance": 8359,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "wartortle": [
    {
      "slug": "drop-water-gem",
      "chance": 71899,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 46696,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "squirtle-hull",
      "chance": 3459,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 519,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "blastoise": [
    {
      "slug": "drop-water-gem",
      "chance": 80000,
      "min": 1,
      "max": 43,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 40500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "squirtle-hull",
      "chance": 4300,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "caterpie": [
    {
      "slug": "bug-gosme",
      "chance": 73352,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 73352,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 4776,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "metapod": [
    {
      "slug": "bug-gosme",
      "chance": 72169,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 72169,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 3190,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "butterfree": [
    {
      "slug": "bug-gosme",
      "chance": 71140,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 71140,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 38384,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 14394,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 6878,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 479,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "weedle": [
    {
      "slug": "bug-gosme",
      "chance": 69723,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 69723,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 69723,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bee-sting",
      "chance": 4302,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kakuna": [
    {
      "slug": "bug-gosme",
      "chance": 72225,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 72225,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 72225,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bee-sting",
      "chance": 3243,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "beedrill": [
    {
      "slug": "bug-gosme",
      "chance": 75000,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 25987,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 10394,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bee-sting",
      "chance": 4966,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 346,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "cocoon-stone",
      "chance": 346,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pidgey": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 12986,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 4330,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "pidgeotto": [
    {
      "slug": "rubber-ball",
      "chance": 51615,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 51615,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 3872,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 710,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 194,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "feather-stone",
      "chance": 194,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pidgeot": [
    {
      "slug": "ancient-stone",
      "chance": 74,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "straw",
      "chance": 59573,
      "min": 1,
      "max": 19,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 59573,
      "min": 1,
      "max": 19,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 16829,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 16755,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 3202,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 373,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "feather-stone",
      "chance": 373,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "rattata": [
    {
      "slug": "rubber-ball",
      "chance": 68636,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 68636,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rat-tail",
      "chance": 6762,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "raticate": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 64958,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rat-tail",
      "chance": 8594,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "spearow": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "red-wing",
      "chance": 2404,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "fearow": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 34648,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 34418,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "red-wing",
      "chance": 9867,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "feather-stone",
      "chance": 688,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ekans": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snake-tail",
      "chance": 2999,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "arbok": [
    {
      "slug": "drop-poison-bottle",
      "chance": 73329,
      "min": 1,
      "max": 18,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 45649,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snake-tail",
      "chance": 7697,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 538,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pikachu": [
    {
      "slug": "screw",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 51978,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "electric-rat-tail",
      "chance": 6116,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 918,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "raichu": [
    {
      "slug": "screw",
      "chance": 72242,
      "min": 1,
      "max": 43,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 58717,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "electric-rat-tail",
      "chance": 8278,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 962,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sandshrew": [
    {
      "slug": "earth-ball",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 56659,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "armadillo-claw",
      "chance": 6697,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "sandslash": [
    {
      "slug": "earth-ball",
      "chance": 75000,
      "min": 1,
      "max": 33,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 43311,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "armadillo-claw",
      "chance": 7602,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 884,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nidorina": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 29689,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "female-ear",
      "chance": 4029,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 637,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nidoqueen": [
    {
      "slug": "drop-poison-bottle",
      "chance": 74669,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 74669,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 32397,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "female-ear",
      "chance": 5686,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 661,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "venom-stone",
      "chance": 661,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nidorino": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 26682,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "male-ear",
      "chance": 3621,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 572,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nidoking": [
    {
      "slug": "drop-poison-bottle",
      "chance": 73061,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 73061,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 31700,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "male-ear",
      "chance": 5564,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 646,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "venom-stone",
      "chance": 646,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "clefairy": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 16522,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "topknot",
      "chance": 3437,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 397,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "clefable": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 33,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 41950,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "topknot",
      "chance": 9020,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 629,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "vulpix": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 9322,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 8391,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 932,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "ninetales": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 33,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 11517,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 10632,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 6380,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 531,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "jigglypuff": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 17624,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 423,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "microphone",
      "chance": 705,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "wigglytuff": [
    {
      "slug": "rubber-ball",
      "chance": 69500,
      "min": 1,
      "max": 33,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 35019,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "microphone",
      "chance": 7004,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 526,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "zubat": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bat-wing",
      "chance": 2470,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "golbat": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 9,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 9,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 48022,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bat-wing",
      "chance": 8098,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 564,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "oddish": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 3452,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 1151,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gloom": [
    {
      "slug": "drop-seed",
      "chance": 74033,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 74033,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 8596,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 2407,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 344,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "leaf-stone",
      "chance": 344,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "vileplume": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 23302,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 6680,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 466,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "leaf-stone",
      "chance": 466,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "paras": [
    {
      "slug": "bug-gosme",
      "chance": 72748,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 72748,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 2656,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "mushroom",
      "chance": 2480,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 72748,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "parasect": [
    {
      "slug": "drop-seed",
      "chance": 72006,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 72006,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 19432,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "mushroom",
      "chance": 5570,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 388,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "cocoon-stone",
      "chance": 388,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 25910,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "venonat": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 9186,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 6124,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 2297,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 22966,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "venomoth": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 18394,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 5273,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 368,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "venom-stone",
      "chance": 368,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "diglett": [
    {
      "slug": "earth-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 4446,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "piece-of-diglett",
      "chance": 1000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 166,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "dugtrio": [
    {
      "slug": "earth-ball",
      "chance": 75000,
      "min": 1,
      "max": 18,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 29794,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "piece-of-diglett",
      "chance": 8266,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 577,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "meowth": [
    {
      "slug": "rubber-ball",
      "chance": 71155,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "nail",
      "chance": 19085,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "wool-ball",
      "chance": 13558,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 658,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "iron-bracelet",
      "chance": 658,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "persian": [
    {
      "slug": "rubber-ball",
      "chance": 71340,
      "min": 1,
      "max": 15,
      "stone": false
    },
    {
      "slug": "wool-ball",
      "chance": 41038,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "nail",
      "chance": 32087,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 506,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "psyduck": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "psyduck-mug",
      "chance": 8480,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "golduck": [
    {
      "slug": "drop-water-gem",
      "chance": 73918,
      "min": 1,
      "max": 28,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 56722,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "karate-duck",
      "chance": 14945,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "air-tank",
      "chance": 900,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 539,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "diving-mask",
      "chance": 900,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fins",
      "chance": 900,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "mankey": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 16544,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "iron-bracelet",
      "chance": 3910,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "primeape": [
    {
      "slug": "rubber-ball",
      "chance": 71936,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 71936,
      "min": 1,
      "max": 25,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 23343,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "iron-bracelet",
      "chance": 6274,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 438,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "growlithe": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 54186,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 47812,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "giant-piece-of-fur",
      "chance": 8288,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "nail",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "arcanine": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 40,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 32257,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 30967,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "giant-piece-of-fur",
      "chance": 5548,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 129,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "fire-stone",
      "chance": 386,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "nail",
      "chance": 25805,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "poliwag": [
    {
      "slug": "drop-water-gem",
      "chance": 73948,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 73948,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 1,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "poliwhirl": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 47980,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 3412,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 640,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "poliwrath": [
    {
      "slug": "band-aid",
      "chance": 75000,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 59374,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 14284,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 516,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "water-stone",
      "chance": 516,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "abra": [
    {
      "slug": "enchanted-gem",
      "chance": 60658,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 60658,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 1,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kadabra": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 61926,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 6061,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 790,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "alakazam": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 40,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 15041,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 1049,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "machop": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-champion-belt",
      "chance": 1802,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "machoke": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 75000,
      "min": 1,
      "max": 23,
      "stone": false
    },
    {
      "slug": "drop-champion-belt",
      "chance": 928,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 556,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "machamp": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 75000,
      "min": 1,
      "max": 40,
      "stone": false
    },
    {
      "slug": "drop-champion-belt",
      "chance": 4074,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 815,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "bellsprout": [
    {
      "slug": "drop-seed",
      "chance": 68978,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 68978,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 68978,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "plant-tail",
      "chance": 2605,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "weepinbell": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 32360,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "plant-tail",
      "chance": 2471,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 352,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "leaf-stone",
      "chance": 352,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "victreebel": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 49074,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "plant-tail",
      "chance": 11637,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 421,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "leaf-stone",
      "chance": 421,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "tentacool": [
    {
      "slug": "drop-water-gem",
      "chance": 73756,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 73756,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "ruby",
      "chance": 5413,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "giant-ruby",
      "chance": 601,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 12030,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "tentacruel": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "ruby",
      "chance": 23813,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "giant-ruby",
      "chance": 4267,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "diving-mask",
      "chance": 496,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "air-tank",
      "chance": 496,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 297,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "water-stone",
      "chance": 297,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "fins",
      "chance": 496,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 14883,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "tentacruel-tentacle",
      "chance": 496,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "geodude": [
    {
      "slug": "small-stone",
      "chance": 74183,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 74183,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 6570,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-rock",
      "chance": 226,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 136,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "graveler": [
    {
      "slug": "earth-ball",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 24062,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-rock",
      "chance": 2625,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 328,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "rock-stone",
      "chance": 328,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "golem": [
    {
      "slug": "earth-ball",
      "chance": 72934,
      "min": 1,
      "max": 18,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 72934,
      "min": 1,
      "max": 18,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 38175,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-rock",
      "chance": 5295,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 616,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "rock-stone",
      "chance": 616,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ponyta": [
    {
      "slug": "drop-essence-fire",
      "chance": 71036,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 15302,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-horse-foot",
      "chance": 1243,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 478,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 287,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "rapidash": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 25,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 47614,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-horse-foot",
      "chance": 15808,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 572,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "future-orb",
      "chance": 952,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 572,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "slowpoke": [
    {
      "slug": "drop-water-gem",
      "chance": 73797,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 73797,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 11895,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "slow-tail",
      "chance": 3050,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "slowbro": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 43581,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "slow-tail",
      "chance": 13610,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 459,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magnemite": [
    {
      "slug": "screw",
      "chance": 75000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "piece-of-steel",
      "chance": 75000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 15751,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 5968,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "magneton": [
    {
      "slug": "piece-of-steel",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 49582,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 27125,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 876,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "neodymium-magnet",
      "chance": 1458,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "magnetic-cube",
      "chance": 292,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "farfetchd": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 74499,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "farfetchd-stick",
      "chance": 8658,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "feather-stone",
      "chance": 604,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "doduo": [
    {
      "slug": "straw",
      "chance": 74054,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 74054,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 12653,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dodrio-feather",
      "chance": 3850,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "dodrio": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 20434,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dodrio-feather",
      "chance": 6461,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 451,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "feather-stone",
      "chance": 451,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "chicken-feet",
      "chance": 752,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dodo-cube",
      "chance": 150,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "seel": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 37931,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 16256,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "seal-tail",
      "chance": 3523,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "dewgong": [
    {
      "slug": "drop-water-gem",
      "chance": 65386,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 65386,
      "min": 1,
      "max": 16,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 22476,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 15938,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "seal-tail",
      "chance": 3514,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ski-poles",
      "chance": 409,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 409,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "ice-stone",
      "chance": 409,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "goggles",
      "chance": 409,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snow-skis",
      "chance": 409,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "grimer": [
    {
      "slug": "drop-poison-bottle",
      "chance": 69954,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 9832,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "muk": [
    {
      "slug": "drop-poison-bottle",
      "chance": 72872,
      "min": 1,
      "max": 42,
      "stone": false
    },
    {
      "slug": "sticky-hand",
      "chance": 15937,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 590,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "gosme",
      "chance": 29513,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "shellder": [
    {
      "slug": "drop-water-gem",
      "chance": 70033,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 19337,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "locksmith-of-shell",
      "chance": 7558,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 5273,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "cloyster": [
    {
      "slug": "drop-water-gem",
      "chance": 61126,
      "min": 1,
      "max": 15,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 61126,
      "min": 1,
      "max": 15,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 19865,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 13754,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-spike",
      "chance": 3286,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 382,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "ice-stone",
      "chance": 382,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "goggles",
      "chance": 382,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ski-poles",
      "chance": 382,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snow-skis",
      "chance": 382,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gastly": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-ghost-trace",
      "chance": 10904,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "haunter": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 75000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "drop-ghost-trace",
      "chance": 4422,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 577,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "venom-stone",
      "chance": 577,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "gengar": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 75000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "drop-ghost-trace",
      "chance": 9539,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 900,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "venom-stone",
      "chance": 900,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "onix": [
    {
      "slug": "earth-ball",
      "chance": 51510,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 51510,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 16097,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "onix-tail",
      "chance": 2769,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 193,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "rock-stone",
      "chance": 193,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "crystal-stone",
      "chance": 64,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "crystal-tail",
      "chance": 322,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-cube",
      "chance": 64,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "drowzee": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 13,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 62875,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 6826,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "hypno": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 28,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 45035,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 7307,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 510,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "krabby": [
    {
      "slug": "drop-water-gem",
      "chance": 74506,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 74506,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crab-claw",
      "chance": 1957,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kingler": [
    {
      "slug": "drop-water-gem",
      "chance": 73990,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 69610,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crab-claw",
      "chance": 11086,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 773,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "voltorb": [
    {
      "slug": "screw",
      "chance": 47432,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 47432,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "electrode": [
    {
      "slug": "screw",
      "chance": 73840,
      "min": 1,
      "max": 18,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 31229,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 604,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "exeggcute": [
    {
      "slug": "drop-seed",
      "chance": 74576,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 74576,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 74576,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "plant-foot",
      "chance": 1460,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "exeggutor": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 14,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 14,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "plant-foot",
      "chance": 34717,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 1256,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cubone": [
    {
      "slug": "earth-ball",
      "chance": 72357,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 53370,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-bone",
      "chance": 7277,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "marowak": [
    {
      "slug": "earth-ball",
      "chance": 71204,
      "min": 1,
      "max": 28,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 33904,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-bone",
      "chance": 6781,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 789,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hitmonlee": [
    {
      "slug": "rubber-ball",
      "chance": 72175,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 72175,
      "min": 1,
      "max": 30,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 6509,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 5598,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 651,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hitmonchan": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "band-aid",
      "chance": 75000,
      "min": 1,
      "max": 30,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 6985,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-machine",
      "chance": 6007,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 698,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lickitung": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 28,
      "stone": false
    },
    {
      "slug": "tongue",
      "chance": 7783,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 543,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "koffing": [
    {
      "slug": "drop-poison-bottle",
      "chance": 71624,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "venom-flute",
      "chance": 1121,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 9336,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "weezing": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 18,
      "stone": false
    },
    {
      "slug": "venom-flute",
      "chance": 15719,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 1096,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "rhyhorn": [
    {
      "slug": "earth-ball",
      "chance": 69454,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 69454,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 50197,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 25099,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "horn-drill",
      "chance": 837,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 33465,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "rhydon": [
    {
      "slug": "ancient-stone",
      "chance": 69,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "earth-ball",
      "chance": 55311,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 41483,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 20741,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 13828,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "horn-drill",
      "chance": 1382,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 20741,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 346,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "earth-stone",
      "chance": 346,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "chansey": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "chansey-egg",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "tangela": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 1146,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "blue-vines",
      "chance": 1911,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kangaskhan": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 47699,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "kanga-ear",
      "chance": 1591,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 955,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "horsea": [
    {
      "slug": "drop-water-gem",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "seahorse-tail",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "seadra": [
    {
      "slug": "drop-water-gem",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 25000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "seahorse-tail",
      "chance": 2000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "air-tank",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "diving-mask",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fins",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "goldeen": [
    {
      "slug": "drop-water-gem",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "blue-fish-fin",
      "chance": 100,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "seaking": [
    {
      "slug": "drop-water-gem",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 2000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "air-tank",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "diving-mask",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fins",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "staryu": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "starmie": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "mr-mime": [
    {
      "slug": "rubber-ball",
      "chance": 72994,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 72994,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 72994,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "mimic-clothes",
      "chance": 1678,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 1007,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "scyther": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 55267,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 36845,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "scythe",
      "chance": 921,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 921,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "feather-stone",
      "chance": 921,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "jynx": [
    {
      "slug": "enchanted-gem",
      "chance": 36382,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 36382,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 27286,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 13643,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "goggles",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ski-poles",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snow-skis",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "enigma-stone",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "ancient-stone",
      "chance": 136,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "electabuzz": [
    {
      "slug": "screw",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 1566,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 1566,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magmar": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "magma-foot",
      "chance": 2225,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 1334,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pinsir": [
    {
      "slug": "bug-gosme",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "pot-of-moss-bug",
      "chance": 73656,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "pinsir-horn",
      "chance": 1841,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 1841,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "tauros": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 30087,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bull-tail",
      "chance": 1003,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 602,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magikarp": [
    {
      "slug": "drop-water-gem",
      "chance": 45000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 11250,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 7500,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gyarados": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 39044,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 39044,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "gyarados-tail",
      "chance": 650,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 390,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "crystal-stone",
      "chance": 130,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "air-tank",
      "chance": 650,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "diving-mask",
      "chance": 650,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fins",
      "chance": 650,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "lapras": [
    {
      "slug": "snowball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 50683,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 42236,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "giant-fin",
      "chance": 844,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 507,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "water-stone",
      "chance": 507,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "goggles",
      "chance": 844,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ski-poles",
      "chance": 844,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snow-skis",
      "chance": 844,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "ditto": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "eevee": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "vaporeon": [
    {
      "slug": "drop-water-gem",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "jolteon": [
    {
      "slug": "screw",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "flareon": [
    {
      "slug": "drop-essence-fire",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "porygon": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "omanyte": [
    {
      "slug": "small-stone",
      "chance": 74219,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 74219,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 62643,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "helix-fossil",
      "chance": 1566,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "omastar": [
    {
      "slug": "small-stone",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "kabuto": [
    {
      "slug": "small-stone",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 71694,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dome-fossil",
      "chance": 1792,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kabutops": [
    {
      "slug": "small-stone",
      "chance": 73314,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 36657,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 30548,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dome-fossil",
      "chance": 2444,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 367,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "crystal-stone",
      "chance": 122,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "aerodactyl": [
    {
      "slug": "straw",
      "chance": 60000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 22500,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "old-amber",
      "chance": 75,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 225,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "ancient-stone",
      "chance": 75,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "snorlax": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 1546,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "articuno": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 30000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "zapdos": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 30000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "moltres": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-essence-fire",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 30000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "dratini": [
    {
      "slug": "dragon-scale",
      "chance": 75000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 75000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-dragon-tooth",
      "chance": 3640,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 3640,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "dragonair": [
    {
      "slug": "dragon-scale",
      "chance": 31850,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 10616,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-dragon-tooth",
      "chance": 1061,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 1061,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 160,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "goggles",
      "chance": 266,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ski-poles",
      "chance": 266,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snow-skis",
      "chance": 266,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "dragonite": [
    {
      "slug": "straw",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 66310,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 33155,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-dragon-tooth",
      "chance": 4420,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 4420,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 110,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "goggles",
      "chance": 553,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ski-poles",
      "chance": 553,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snow-skis",
      "chance": 553,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "mewtwo": [
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "mew": [
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 60000,
      "min": 1,
      "max": 3,
      "stone": false
    }
  ],
  "chikorita": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 27387,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 6320,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 316,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "bayleef": [
    {
      "slug": "drop-seed",
      "chance": 71999,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 41199,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "plant-tail",
      "chance": 12359,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 4120,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 309,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "meganium": [
    {
      "slug": "drop-seed",
      "chance": 66652,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 52556,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "plant-tail",
      "chance": 19112,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 7644,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 477,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cyndaquil": [
    {
      "slug": "drop-essence-fire",
      "chance": 15781,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 3945,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 1578,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 59,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "quilava": [
    {
      "slug": "drop-essence-fire",
      "chance": 28024,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 175,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 4204,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 105,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "typhlosion": [
    {
      "slug": "drop-essence-fire",
      "chance": 49730,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 22068,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "magma-foot",
      "chance": 6216,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 310,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "totodile": [
    {
      "slug": "fish-fin",
      "chance": 1038,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 25958,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 4154,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 312,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "croconaw": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 2611,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 41766,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "crab-claw",
      "chance": 12530,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 314,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "feraligatr": [
    {
      "slug": "fish-fin",
      "chance": 4504,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 30033,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "giant-fin",
      "chance": 7208,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 3003,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 301,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sentret": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "rat-tail",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 30000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 6000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "furret": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "rat-tail",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "giant-piece-of-fur",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hoothoot": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 6000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "noctowl": [
    {
      "slug": "straw",
      "chance": 50869,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 50869,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 50869,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 25434,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 7630,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "feather-stone",
      "chance": 318,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ledyba": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 8000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "ledian": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 40000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "spinarak": [
    {
      "slug": "bug-gosme",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 12000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ariados": [
    {
      "slug": "bug-gosme",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 40000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 20000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "crobat": [
    {
      "slug": "ancient-stone",
      "chance": 20,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "straw",
      "chance": 16372,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bat-wing",
      "chance": 16372,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 9209,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 3070,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 102,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "chinchou": [
    {
      "slug": "screw",
      "chance": 28564,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 28564,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 178,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 7141,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 2857,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 107,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lanturn": [
    {
      "slug": "screw",
      "chance": 47924,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 5691,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 20966,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 8986,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 2996,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 180,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pichu": [
    {
      "slug": "screw",
      "chance": 66728,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "electric-rat-tail",
      "chance": 935,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 18711,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 281,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cleffa": [
    {
      "slug": "rubber-ball",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 3864,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 16559,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 331,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "igglybuff": [
    {
      "slug": "rubber-ball",
      "chance": 39206,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "microphone",
      "chance": 245,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 9802,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 147,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "togepi": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "chansey-egg",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "togetic": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "natu": [
    {
      "slug": "straw",
      "chance": 59112,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 59112,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 59112,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 11084,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 4433,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 222,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "xatu": [
    {
      "slug": "feather-stone",
      "chance": 64,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "straw",
      "chance": 51640,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 51640,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 51640,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 19365,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 7746,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 322,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mareep": [
    {
      "slug": "screw",
      "chance": 10280,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "wool-ball",
      "chance": 10280,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 2570,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 38,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "flaaffy": [
    {
      "slug": "screw",
      "chance": 11641,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "wool-ball",
      "chance": 11641,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 4366,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 1746,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 44,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ampharos": [
    {
      "slug": "screw",
      "chance": 18534,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "wool-ball",
      "chance": 18534,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 116,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 3476,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 116,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "bellossom": [
    {
      "slug": "drop-seed",
      "chance": 25656,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 25656,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 160,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 6414,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 97,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "marill": [
    {
      "slug": "rubber-ball",
      "chance": 70736,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 1002,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 10022,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 301,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "azumarill": [
    {
      "slug": "rubber-ball",
      "chance": 37626,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 8231,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 8466,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 3763,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 141,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sudowoodo": [
    {
      "slug": "small-stone",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "strange-rock",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "politoed": [
    {
      "slug": "fish-fin",
      "chance": 266,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "tongue",
      "chance": 13310,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 4259,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 160,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hoppip": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "skiploom": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 30000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "jumpluff": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 80000,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 40000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "aipom": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "tongue",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "sticky-hand",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "sunkern": [
    {
      "slug": "drop-seed",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 8000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "sunflora": [
    {
      "slug": "drop-seed",
      "chance": 71502,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 7559,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 24739,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 412,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "yanma": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 30000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "goggles",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "wooper": [
    {
      "slug": "drop-water-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 3000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 8000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "quagsire": [
    {
      "slug": "drop-water-gem",
      "chance": 60730,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 6073,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 22774,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "water-stone",
      "chance": 227,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "espeon": [
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 14,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 8500,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 1500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "umbreon": [
    {
      "slug": "dark-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 7000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "crystal-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "murkrow": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "slowking": [
    {
      "slug": "ancient-stone",
      "chance": 100,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "drop-water-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 11,
      "stone": false
    },
    {
      "slug": "slow-tail",
      "chance": 31500,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "locksmith-of-shell",
      "chance": 20000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "misdreavus": [
    {
      "slug": "drop-ghost-essence",
      "chance": 69605,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-ghost-trace",
      "chance": 25382,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 10153,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 634,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "unown": [
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "wobbuffet": [
    {
      "slug": "enchanted-gem",
      "chance": 42403,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 10336,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "tongue",
      "chance": 13251,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 5300,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 159,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "girafarig": [
    {
      "slug": "rubber-ball",
      "chance": 38554,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 38554,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 38554,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 12048,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "tongue",
      "chance": 5783,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 242,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pineco": [
    {
      "slug": "drop-bug-antenna",
      "chance": 2768,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 866,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 10,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "forretress": [
    {
      "slug": "bug-gosme",
      "chance": 17504,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 17504,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "piece-of-steel",
      "chance": 6564,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 3282,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 66,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "dunsparce": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "snake-tail",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gligar": [
    {
      "slug": "straw",
      "chance": 27619,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 27619,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 8631,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-spike",
      "chance": 4143,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 104,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "steelix": [
    {
      "slug": "metal-stone",
      "chance": 59,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "earth-ball",
      "chance": 47662,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "onix-tail",
      "chance": 9235,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "piece-of-steel",
      "chance": 20852,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "iron-bracelet",
      "chance": 8937,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 179,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "snubbull": [
    {
      "slug": "rubber-ball",
      "chance": 51233,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 51233,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 16011,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 192,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "granbull": [
    {
      "slug": "rubber-ball",
      "chance": 69704,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 69704,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 58727,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 16780,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 504,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "qwilfish": [
    {
      "slug": "drop-water-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "strange-spike",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-poison-bottle",
      "chance": 18000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "scizor": [
    {
      "slug": "metal-stone",
      "chance": 62,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "bug-gosme",
      "chance": 49004,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "scythe",
      "chance": 5818,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "piece-of-steel",
      "chance": 18376,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "pinsir-horn",
      "chance": 7350,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 184,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shuckle": [
    {
      "slug": "small-stone",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "locksmith-of-shell",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "heracross": [
    {
      "slug": "band-aid",
      "chance": 74204,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "bug-gosme",
      "chance": 74204,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "pinsir-horn",
      "chance": 3722,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 37222,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 18610,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 620,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sneasel": [
    {
      "slug": "dark-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "crystal-tail",
      "chance": 9500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 15000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "teddiursa": [
    {
      "slug": "rubber-ball",
      "chance": 65788,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 65788,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 20559,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 8224,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "ursaring": [
    {
      "slug": "ancient-stone",
      "chance": 56,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "rubber-ball",
      "chance": 45056,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 45056,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "giant-piece-of-fur",
      "chance": 16896,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 11264,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 169,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "slugma": [
    {
      "slug": "drop-essence-fire",
      "chance": 5486,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 5486,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "magma-foot",
      "chance": 1372,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 20,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magcargo": [
    {
      "slug": "drop-essence-fire",
      "chance": 45410,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "pot-of-lava",
      "chance": 45410,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "magma-foot",
      "chance": 5960,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 8514,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 170,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "swinub": [
    {
      "slug": "earth-ball",
      "chance": 34580,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 34580,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 10806,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 3458,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 130,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "piloswine": [
    {
      "slug": "earth-ball",
      "chance": 67479,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 67479,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "giant-piece-of-fur",
      "chance": 25304,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 12652,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 422,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "corsola": [
    {
      "slug": "small-stone",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "remoraid": [
    {
      "slug": "drop-water-gem",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fish-fin",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "blue-fish-fin",
      "chance": 20000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "octillery": [
    {
      "slug": "fish-fin",
      "chance": 9000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "tentacruel-tentacle",
      "chance": 1500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "delibird": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mantine": [
    {
      "slug": "ancient-stone",
      "chance": 41,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "straw",
      "chance": 33151,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "giant-fin",
      "chance": 7252,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "fins",
      "chance": 1450,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 4144,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 124,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "skarmory": [
    {
      "slug": "metal-stone",
      "chance": 112,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "feather-stone",
      "chance": 112,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "straw",
      "chance": 70064,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 70064,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "piece-of-steel",
      "chance": 33749,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "bird-beak",
      "chance": 16875,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "iron-bracelet",
      "chance": 6750,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "houndour": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 518,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 25882,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 10353,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 310,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "houndoom": [
    {
      "slug": "drop-essence-fire",
      "chance": 43879,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 43879,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 21391,
      "min": 1,
      "max": 6,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 16454,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 9872,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 165,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "fire-stone",
      "chance": 165,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "kingdra": [
    {
      "slug": "drop-water-gem",
      "chance": 56588,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "seahorse-tail",
      "chance": 6720,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 17684,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 8488,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 212,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "phanpy": [
    {
      "slug": "earth-ball",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 21531,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 322,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "donphan": [
    {
      "slug": "earth-ball",
      "chance": 70067,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 45764,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-rock",
      "chance": 19613,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 654,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "porygon2": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "crystal-cube",
      "chance": 9000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "magnetic-cube",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "stantler": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 80000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "horn",
      "chance": 30000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "smeargle": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 80000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "tongue",
      "chance": 25000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-thing",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "tyrogue": [
    {
      "slug": "band-aid",
      "chance": 36484,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 36484,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "punch-machine",
      "chance": 9121,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 136,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hitmontop": [
    {
      "slug": "band-aid",
      "chance": 50422,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 315,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 15757,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "topknot",
      "chance": 7564,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 315,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "smoochum": [
    {
      "slug": "enchanted-gem",
      "chance": 75000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "female-ear",
      "chance": 604,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 24153,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 14492,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 362,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "elekid": [
    {
      "slug": "screw",
      "chance": 19640,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-electric-box",
      "chance": 19640,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 4910,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 74,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magby": [
    {
      "slug": "drop-essence-fire",
      "chance": 70994,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 19906,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 299,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "miltank": [
    {
      "slug": "rubber-ball",
      "chance": 49556,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 49556,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "bull-tail",
      "chance": 3406,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "giant-piece-of-fur",
      "chance": 9292,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 310,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "blissey": [
    {
      "slug": "rubber-ball",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "chansey-egg",
      "chance": 1000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fur",
      "chance": 30000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 300,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "raikou": [
    {
      "slug": "screw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 14500,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 40000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "thunder-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "entei": [
    {
      "slug": "fire-tail",
      "chance": 53000,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-essence-fire",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magma-foot",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 1000,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "suicune": [
    {
      "slug": "giant-fin",
      "chance": 17000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 40000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "water-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "larvitar": [
    {
      "slug": "small-stone",
      "chance": 74041,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 60938,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 24375,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 731,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pupitar": [
    {
      "slug": "ancient-stone",
      "chance": 65,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "earth-ball",
      "chance": 52196,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 52196,
      "min": 1,
      "max": 10,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 19574,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "strange-rock",
      "chance": 7829,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "rock-stone",
      "chance": 196,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "tyranitar": [
    {
      "slug": "ancient-stone",
      "chance": 48,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "small-stone",
      "chance": 38140,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 38140,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 38140,
      "min": 1,
      "max": 12,
      "stone": false
    },
    {
      "slug": "giant-ruby",
      "chance": 11919,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "drop-tooth",
      "chance": 8582,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 143,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "rock-stone",
      "chance": 143,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lugia": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 20,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 80000,
      "min": 1,
      "max": 15,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 9500,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "psychic-spoon",
      "chance": 20000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "enigma-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ho-oh": [
    {
      "slug": "straw",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "red-wing",
      "chance": 26500,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "colored-feather",
      "chance": 10000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "drop-essence-fire",
      "chance": 20000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "fire-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "celebi": [
    {
      "slug": "drop-seed",
      "chance": 80000,
      "min": 1,
      "max": 5,
      "stone": false
    },
    {
      "slug": "enchanted-gem",
      "chance": 80000,
      "min": 1,
      "max": 15,
      "stone": false
    },
    {
      "slug": "strange-flower",
      "chance": 25000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bag-of-pollen",
      "chance": 40000,
      "min": 1,
      "max": 3,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 20000,
      "min": 1,
      "max": 2,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    },
    {
      "slug": "enigma-stone",
      "chance": 500,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nidoran-f": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nidoran-m": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "treecko": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "grovyle": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sceptile": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "torchic": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "combusken": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "blaziken": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mudkip": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "marshtomp": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "swampert": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "poochyena": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mightyena": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "zigzagoon": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "linoone": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "wurmple": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "silcoon": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "beautifly": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cascoon": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 1000,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "dustox": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 1200,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lotad": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lombre": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ludicolo": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "seedot": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nuzleaf": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shiftry": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "taillow": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "swellow": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "wingull": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pelipper": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ralts": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "kirlia": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "gardevoir": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "surskit": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "masquerain": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shroomish": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "breloom": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "slakoth": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "vigoroth": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "slaking": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "nincada": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ninjask": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shedinja": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "whismur": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "loudred": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "exploud": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "makuhita": [
    {
      "slug": "drop-champion-belt",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hariyama": [
    {
      "slug": "drop-champion-belt",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "nosepass": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "skitty": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "delcatty": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "sableye": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-ghost-trace",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mawile": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "aron": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "lairon": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "aggron": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-stone-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "meditite": [
    {
      "slug": "drop-champion-belt",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "medicham": [
    {
      "slug": "drop-champion-belt",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "electrike": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "manectric": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "plusle": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "minun": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "volbeat": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "illumise": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "roselia": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "gulpin": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "swalot": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "carvanha": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sharpedo": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "wailmer": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "wailord": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "numel": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "camerupt": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "torkoal": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "spoink": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "grumpig": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "spinda": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "trapinch": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "vibrava": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "flygon": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cacnea": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cacturne": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "swablu": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "altaria": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "zangoose": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "seviper": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lunatone": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "solrock": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "barboach": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "whiscash": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "corphish": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "crawdaunt": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "baltoy": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "claydol": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lileep": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cradily": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-seed",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "anorith": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "armaldo": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-bug-antenna",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "feebas": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "milotic": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "castform": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kecleon": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "shuppet": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "banette": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "duskull": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "dusclops": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "tropius": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "chimecho": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "absol": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "snorunt": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "glalie": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "spheal": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "sealeo": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "walrein": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-water-gem",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "clamperl": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "huntail": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "gorebyss": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "relicanth": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "luvdisc": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "bagon": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "shelgon": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "salamence": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "beldum": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "metang": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "metagross": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "regirock": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "regice": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "registeel": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "kyogre": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "groudon": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "rayquaza": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "jirachi": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "turtwig": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "grotle": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "torterra": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "chimchar": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "monferno": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "infernape": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "piplup": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "prinplup": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "empoleon": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "starly": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "staravia": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "staraptor": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "bidoof": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "bibarel": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "kricketot": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "kricketune": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shinx": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "luxio": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "luxray": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "budew": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "roserade": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cranidos": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "rampardos": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shieldon": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "bastiodon": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "burmy": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "wormadam": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mothim": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "combee": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "vespiquen": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "pachirisu": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "buizel": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "floatzel": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cherubi": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "cherrim": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shellos": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "gastrodon": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "ambipom": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "drifloon": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "drifblim": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "buneary": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "lopunny": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "mismagius": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "honchkrow": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "glameow": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "purugly": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "chingling": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "stunky": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "skuntank": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "bronzor": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "bronzong": [
    {
      "slug": "magnet",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "neodymium-magnet",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "future-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "bonsly": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mime-jr": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-luck-medal",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "happiny": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "chatot": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "spiritomb": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-fox-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gible": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gabite": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "garchomp": [
    {
      "slug": "drop-dragon-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dragon-scale",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "dragon-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "riolu": [
    {
      "slug": "drop-champion-belt",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lucario": [
    {
      "slug": "drop-champion-belt",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "martial-arts-scroll",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "kick-machine",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "punch-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hippopotas": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "hippowdon": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "skorupi": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "drapion": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "croagunk": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "toxicroak": [
    {
      "slug": "drop-poison-bottle",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "gosme",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "venom-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "carnivine": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "finneon": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lumineon": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mantyke": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "snover": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "abomasnow": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "weavile": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-ice-orb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magnezone": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "lickilicky": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "rhyperior": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "tangrowth": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "electivire": [
    {
      "slug": "drop-electric-box",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "screw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "electric-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "thunder-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "magmortar": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "togekiss": [
    {
      "slug": "drop-luck-medal",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "comb",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-feather",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "heart-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "yanmega": [
    {
      "slug": "drop-bug-antenna",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bug-venom",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "butterfly-wing",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "cocoon-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "leafeon": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 1600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "glaceon": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 1800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "gliscor": [
    {
      "slug": "drop-bone",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "earth-ball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "sandbag",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "earth-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "mamoswine": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-bone",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "porygon-z": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "gallade": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-champion-belt",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 1000,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "probopass": [
    {
      "slug": "drop-stone-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "small-stone",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magnet",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "crystal-stone",
      "chance": 600,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "dusknoir": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    }
  ],
  "froslass": [
    {
      "slug": "drop-ice-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "snowball",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-ghost-trace",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "ice-stone",
      "chance": 800,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "uxie": [
    {
      "slug": "future-orb",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "linearly-guided-hypnosis",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "enigma-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "palkia": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "heatran": [
    {
      "slug": "drop-essence-fire",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "straw",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "fire-tail",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "fire-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "regigigas": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "giratina": [
    {
      "slug": "drop-ghost-trace",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "drop-ghost-essence",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "drop-dragon-tooth",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ],
  "phione": [
    {
      "slug": "drop-water-gem",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "water-pendant",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "magikarp-fin",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "water-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "darkrai": [
    {
      "slug": "drop-fox-tail",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "dark-gem",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "darkness-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "shaymin": [
    {
      "slug": "drop-seed",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "leaves",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "bulb",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    },
    {
      "slug": "leaf-stone",
      "chance": 400,
      "min": 1,
      "max": 1,
      "stone": true
    }
  ],
  "arceus": [
    {
      "slug": "drop-tooth",
      "chance": 75000,
      "min": 1,
      "max": 8,
      "stone": false
    },
    {
      "slug": "bitten-apple",
      "chance": 45000,
      "min": 1,
      "max": 4,
      "stone": false
    },
    {
      "slug": "rubber-ball",
      "chance": 12000,
      "min": 1,
      "max": 1,
      "stone": false
    }
  ]
};
export function speciesLootTable(slug) {
  if (!slug) return null;
  const key = String(slug).toLowerCase().replace(/_/g, '-');
  return SPECIES_LOOT[key] || null;
}

